import createStore from 'mb-app-common/store/createStore'
import setupPersist, {defaultPersist} from 'mb-app-common/store/setupPersist'

import * as deviceInfo from '../shim/deviceInfo'
import {setDeviceInfo} from 'mb-app-common/lib/shim/deviceInfo'

import rehydratedLogin from './middleware/rehydrated-login'
import appRouter from './middleware/app-router-shim'


export default (history) => {
	const appRouterMiddleware = () => appRouter(history)
	const store = createStore((reducers) => reducers, [rehydratedLogin, appRouterMiddleware])

	const persist = Object.assign({}, defaultPersist)
	persist.Auth = persist.Auth.concat(['token'])
	setupPersist(store, 'local', persist)
	setDeviceInfo(deviceInfo)

	return store
}



// WEBPACK FOOTER //
// ./client/store/createStore.js